import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);
  const Handler = data => {
    setstate({ loading: true });
    FormSubmit({ ...data }).then(() => {
      setstate({
        loading: false,
      });
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت مقاله</title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={state.loading}
        header="ایجاد باکس"
        textbtn="لیست مقالات"
        linkbtn="/Admin/ContentBox/List"
        btnName="ایجاد باکس"
        submit={Handler}
        nested={["cities", "category"]}
        textEditor={"content"}
      />
    </Fragment>
  );
}

export const input = [
  {
    label: "انتخاب دسته بندی",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "category_id",
    input: "select",
    nested: "category",
    noNeed: true,
  },
  {
    label: "انتخاب شهر",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "city_id",
    input: "select",
    nested: "cities",
    noNeed: true,
  },
  {
    label: "محتوا",
    size: "col-md-12",
    classNames: "mt-2",
    name: "content",
    input: "ckeditor",
  },
  {
    label: "کلمات کلیدی سئو",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoKeyword",
    value: "",
    input: "textarea",
  },
  {
    label: "توضیحات کلیدی سئو",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoDescription",
    value: "",
    input: "textarea",
  },
  {
    label: "عنوان صفحه",
    size: "col-md-12",
    classNames: "mt-2",
    name: "seo",
    keyname: "title",
    value: "",
  },
];

export default Create;
